<template>
  <div class="paypage">
    <div class="payname">
      <div class>
        <span>{{userinfo.Name}}</span>
        <span>{{userinfo.CardNumber}}</span>
        <span class="cor" @click="swith()">切换就诊人</span>
        <span class="needle">></span>
      </div>
    </div>
    <div class="paytime">
      <span>就诊时间：</span>
      <span class="sel" @click="checkPickerOption">{{timeType}}</span>
      <!-- <select v-model="timeType">
        <option value="0">七天内</option>
        <option value="1">三个月内</option>
        <option value="2">半年内</option>
      </select>-->
    </div>
    <div>
      <div class="paydeteil" v-for="item in visitList" v-show="isShow">
        <div>
          <p class="pensontit">
            <img src="../../assets/images/penson.png" alt class="pensonpic">
            <span>{{item.PatName}}</span>
            <span>{{item.PatNo}}</span>
            <span class="fontblue" @click="paydetil(item.GUID)">缴费</span>
            <span class="smallicon">></span>
          </p>
          <div class="pd20">
            <p>
              <span>就诊科室：</span>
              <span>{{item.DptName}}</span>
            </p>
            <p>
              <span>就诊医生：</span>
              <span>{{item.DctName}}</span>
            </p>
            <p>
              <span>就诊日期:</span>
              <span class="mr18">{{item.VisitTime}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="noDate" v-show="!isShow">
        <div v-show="true" class="nolist">
          <!-- 无数据显示 -->
          <img src="../../assets/images/searchbg.png" alt class="searchpic">
          <p class="center">暂无数据</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetVisits } from "@/services/getData.js";
import weui from "weui.js";
export default {
  name: "outpatient-home",
  data() {
    return {
      timeType: "七天内",
      userinfo: {},
      visitList: [],
      isShow: true
    };
  },
  created: function() {
    this.getRegisterListByPatID();
    this.userinfo = this.$store.state.userInfo;
  },
  methods: {
    checkPickerOption: function() {
      var _that = this;
      weui.picker(
        [
          {
            label: "七天内",
            value: 0
          },
          {
            label: "三个月内",
            value: 1
          },
          {
            label: "半年内",
            value: 2
          },
          {
            label: "不限时间",
            value: 3
          }
        ],
        {
          onChange: function(result) {
            // console.log(result);
          },
          onConfirm: function(result) {
            _that.timeType = result["0"]["label"];
          }
        }
      );
    },
    swith() {
      //跳转到切换就诊人页
      this.$router.push({ path: "/card/switchcard" });
    },
    paydetil(guid) {
      this.$router.push({
        path: "/pay/outpatientdeteil",
        query: { visitID: guid }
      });
    },
    getRegisterListByPatID() {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      GetVisits(this.timeType).then(response => {
        if (response.data) {
          this.visitList = response.data;
          if (response.data.length > 0) {
            this.isShow = true;
          } else {
            this.isShow = false;
          }
        } else {
        }
      });
      loading.hide();
    }
  }
};
</script>
<style>
.paypage {
  width: 100%;
  height: 100%;
  position: relative;
}

.paypage .payname {
  width: 100%;
  height: 0.8rem;
  background: rgba(21, 146, 228, 1);
  padding: 0 0.2rem;
  font-size: 0.22rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 0.8rem;
  box-sizing: border-box;
}

.payname > div {
  position: relative;
}

.paypage .payname .cor {
  color: #feff82 !important;
  float: right;
  margin-right: 0.4rem;
}

.paypage .needle {
  font-size: 0.31rem;
  font-family: MicrosoftYaHei;
  position: absolute;
  right: 0;
  top: -0.02rem;
}

select {
  outline: none;
  border: 0;
  height: 0.4rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.2rem;
  width: auto;
  padding: 0 0.3rem;
  appearance: none;
  -webkit-appearance: none;
}

.paypage .paytime {
  padding: 0.2rem;
  height: auto;
  font-size: 0.22rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.paypage .paydeteil {
  background: white;
  padding: 0 0.2rem;
  font-size: 0.24rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 0.36rem;
  margin-bottom: 0.2rem;
}

.paypage .paydeteil .pensontit {
  border-bottom: 0.01rem solid rgba(221, 221, 221, 1);
  position: relative;
  box-sizing: border-box;
  padding-top: 0.2rem;
  padding-bottom: 0.18re;
  padding-bottom: 0.14rem;
}

.paypage .paydeteil .pensontit .pensonpic {
  width: 0.22rem;
  height: 0.28rem;
  display: inline-block;
  vertical-align: text-top;
}

.paypage .paydeteil .pensontit .fontblue {
  color: rgba(21, 146, 228, 1) !important;
  float: right;
  margin-right: 0.4rem;
}

.paypage .paydeteil .pensontit .smallicon {
  font-size: 0.31rem;
  font-family: MicrosoftYaHei;
  position: absolute;
  right: 0;
}

.paypage .paydeteil .pd20 {
  padding: 0.2rem 0;
  box-sizing: border-box;
}

.mr18 {
  margin-left: 0.18rem;
}
.paypage .sel {
  width: 1.5rem;
  height: 0.4rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.2rem;
  line-height: 0.4rem;
  /* text-align: center; */
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  padding-left: 0.2rem;
}
.paypage .sel::after {
  position: absolute;
  display: inline-block;
  content: "";
  right: 0.18rem;
  width: 0;
  height: 0rem;
  border-width: 0.11rem 0.07rem;
  border-style: solid;
  border-color: #333333 transparent transparent transparent;
  font-size: 0.18rem;
  color: #fefefe;
  top: 0.15rem;
}

</style>



// WEBPACK FOOTER //
// src/components/outpatientpay/outpatient-home.vue